import { Badge, Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { alarmClock, ReactSvg } from '../../../../shared/vector-images';
import Text from '../../../../shared/_deprecated/elements/Text/Text';

const StyledReminder = styled(Box)`
  ${({ expired }) =>
    expired === 'expired' &&
    css`
      /* border-color: #eb5757; */
      border-color: ${({ theme }) => theme.colors.danger};
    `}
  ${({ expired }) =>
    expired === 'soon' &&
    css`
      /* border-color: #f2994a; */
      border-color: ${({ theme }) => theme.colors.warning};
    `}
`;

const StyledIcon = styled(ReactSvg)`
  flex: 0 0 24px;
  max-width: 24px;
`;

const StyledBadge = styled(Badge)`
  flex: 0 0 auto;
  align-self: flex-start;
  max-width: 50px;
  text-transform: capitalize;
`;

interface ReminderItemProps {
  label: string;
  description: string;
  expired: string;
  action?: (type: string, id: number) => void;
  className?: string;
}

const ReminderItem: FC<ReminderItemProps> = (props) => {
  const { className, action, label, description, expired } = props;

  const theme = useTheme();

  return (
    <StyledReminder
      expired={expired}
      bg="white"
      border="2px solid white"
      p={2}
      borderRadius={10}
      display="flex"
      justifyContent="center"
      alignItems="center"
      onClick={action}
      onKeyDown={action}
      role="link"
      tabIndex={0}
      className={className}
    >
      <Box
        width={40}
        height={40}
        mr={3}
        display="flex"
        flex="0 0 auto"
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
        bg={theme.colors.secondarylight}
      >
        <Box width={24} height={24} flex="0 0 24px">
          <StyledIcon
            toDisplay={alarmClock()}
            options={{
              circleColor: theme.colors.secondarylight,
              fillColor: theme.colors.secondary,
            }}
            width={24}
            height={24}
          />
        </Box>
      </Box>

      <Box overflow="hidden" py={2} flex="1 1 auto">
        <Text size="0" type="light" strong>
          {label}
        </Text>
        <Text size="-1" type="light">
          {description}
        </Text>
      </Box>

      {expired !== 'valid' && (
        <StyledBadge
          shape="round"
          ml={2}
          bg={expired === 'soon' ? theme.colors.warning : theme.colors.danger}
        >
          {expired}
        </StyledBadge>
      )}
    </StyledReminder>
  );
};

ReminderItem.defaultProps = {
  action: undefined,
  className: undefined,
};

export default ReminderItem;
